import React from 'react'
import ScrollToTopButton from '../pages/ScrollToTopButton'
import UnderlineWithIcon from '../components/UnderlineWithIcon';
const Postgrad = () => {
  return (
    <div>
      
 <br/>
 


    <div class="sidebar-page-container">
        <div class="auto-container">
            <div class="row">
                
             
                <div class="content-side col-xl-9 col-lg-8 order-lg-2">
                    <div class="services-single">
                        <div class="inner-box">
                            <div class="big-image">
                                <img src="assets/images/resource/service-9.jpg" alt="" />
                            </div>
                            <div className="sec-title">
              
           
                           <h3 className='campuses-heading' style={{textAlign:'center'}}>SCHOOL OF POSTGRADUATE STUDIES</h3>
								<UnderlineWithIcon/>
                            </div>
                            <div class="text">
                                <p>
                                Admas University keeps track of the needs of the general society, which shapes the academic level upgrading and opening of socially significant fields of study in the institute.
                                 It is in addressing this social responsibility that the university launched its school of postgraduate study, which aims to address the rising demand for Master's degree-level qualified citizens in various disciplines throughout the country.
                                 </p>
                            
                                 
                            </div>

                            <div class="facts">
                                <h3>ADMISSION CRITERIA</h3>
                                <div class="text">
                               &nbsp;&nbsp;&nbsp;&nbsp; To be eligible for admission to our university, applicants must meet the following criteria:
                                </div>
                                    <div>
										&nbsp;&nbsp;&nbsp;&nbsp;<a href ="/mscAdmission"> Click for MSc Admission Criteria </a>
								</div>
                               </div>

                            <div class="featured-blocks">
                                <div class="row">
                                    
                                  
                                    <div class="featured-block col-md-10">
                                        <div class="featured-inner">
                                            <div class="content">
                                                <div class="icon-box">
                                                    <span class="icon flaticon-work-team"></span>
                                                </div>
                                                <h3>DURATION OF THE PROGRAMS</h3>
                                                <div class="text">
                                                All Masters Degree programs are set to be two years with four semesters out of which the three semesters are course work while the last semester is a time for the graduation thesis preparation.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                  
                                    <div className="featured-block col-md-6">
      <div className="featured-inner">
        <div className="content">
          <div className="icon-box">
            <span className="icon flaticon-deadline"></span>
          </div>
          
        </div>
      </div>
    </div>
                                    
                             
                                    
                                   
                                  
                                    
                                </div>
                            </div>
                            
                          
                           
                        </div>
                    </div>
                </div>
                
              
                <div class="sidebar-side col-xl-3 col-lg-4">
                    <aside class="sidebar">
                        
                    



                        <div class="sidebar-widget sidebar-blog-category">
                            <ul class="blog-cat">
								<li class="active"><a href="">POSTGRADUATE STUDIES</a></li>
                                <li><a href="/mscacfn">Accounting and Finance</a></li>
                                <li><a href="/msccs">Computer Science</a></li>
                                <li><a href="/mscmba">Master of Business Administration(MBA)</a></li>
                                <li><a href="/mscmba">Project Management</a></li>
                               
                            </ul>
                        </div>
                        
                    
                      

                      
                        <div class="sidebar-widget contact-info-widget">
                            <div class="sidebar-title style-two">
                                <h2>CONTACT US</h2>
                            </div>
                            <div class="inner-box">
                                <ul>
                                    <li><span class="icon fas fa-phone"></span>0116687671</li>
                                    <li><span class="icon fas fa-paper-plane"></span>https://t.me/AdmasAA</li>
                                </ul>
                            </div>
                        </div>
                        
                    </aside>
                </div>
                
            </div>
        </div>
    </div>
    <ScrollToTopButton/>
    </div>
  )
}

export default Postgrad